import { useHistory } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import { useDispatch } from 'react-redux'
import { clearToken } from './authenticationSlice'
import api from '../api'

const useLogout = () => {
  const history = useHistory()
  const [, , removeCookie] = useCookies(['user_id'])
  const dispatch = useDispatch()

  const logOut = async (soft = false) => {
    if (soft) {
      // Soft logout: Clear Redux state only, keep cookies
      // Used when user clicks "Back" during merge/OAuth flows
      dispatch(clearToken())
      history.push('/sign-in')
    } else {
      // Full logout: Call backend and clear everything
      try {
        await api.post('/auth/logout')
      } catch (error) {
        console.error('Logout error:', error)
      }

      localStorage.removeItem('currentOrganization')
      removeCookie('user_id', { path: '/' })
      dispatch(clearToken())
      history.push('/')
    }
  }

  return logOut
}

export default useLogout
